import React, { useEffect } from "react";
import css from "./ATable.module.scss";
import { NavLink } from "react-router-dom";
import { useDebounce } from "use-debounce";

const ATable = (props) => {
  const { columns, sampleData, FilterSearchAll, CreateButtonWithLink, filter, from, to, total, admin, prev_page, next_page } = props;
  // alert(admin)
  const [inputValue, setInputValue] = React.useState("");
  const [debouncedValue] = useDebounce(inputValue, 300);

  const handleSearchChange = (event) => { setInputValue(event.target.value);};
  const HandlePrevItem = () => { props.prev('prev',1)};
  const HandleNextItem = () => { props.next('next',1)};
  const onChangePerpage = (event) => { props.perpage(event.target.value)};
  
  useEffect(() => {
    if(debouncedValue){
      props.searchData(debouncedValue);
    }else{
      if(props.searchData){
        props.searchData('');
      }
    }
  }, [debouncedValue]);

  const formatNumber = (number) => {
    return new Intl.NumberFormat('en-US', { maximumFractionDigits: 2 }).format(number); 
  };

  return (
    <div>
      {filter && 
        <div className={css.filter}>
          {FilterSearchAll && (
            <>
              <i class="fi fi-rr-search"></i>
              <input type="text" placeholder="Cari data..." onChange={handleSearchChange} />
            </>
          )}
          {CreateButtonWithLink && 
          
          <NavLink to={CreateButtonWithLink}>
            <button className={css.button}>
              <span class="fi fi-rr-plus-small"></span>Create
            </button>
          </NavLink>
          }
        </div>
      }
      <table className={css.table}>
        <tr className={css.tr_header}>
          {columns.map((column, index) => (
            <th key={index} style={{ textAlign: column.align }}>
              {column.title == 'Action' ? <>{admin ? '' : column.title }</> : column.title}
            </th>
          ))}
        </tr>

        {sampleData.map((column, no) => (
          <tr key={no} className={no % 2 === 0 ? css.active_tr : ""}>
            {columns.map((col, index) => (
              <td key={index} style={{ textAlign: col.align }}>
                {
                  col.field == 'no' ?  from+ no  : 
                  col.boolean == true ? <> {col.field == 'is_active' &&  <>{column[col.field] == true ? 'Active' : 'Unactive'}</>}</> : 
                  col.type == 'action' ? 
                  <>
                    {admin == false && 
                      <NavLink to={col.link+'/'+btoa(column[col.primary])}>
                        {col.value}
                      </NavLink>
                    }
                    {/* {col.roleCode} */}
                  </>
                  : 
                  col.status_station == true ? 
                    <>
                      {column[col.field] == 1 && 
                        <div className="status-plts status-disconnect">Disconnected</div>
                      }
                      {column[col.field] == 2 &&                 
                        <div className="status-plts status-faulty">Faulty</div>
                      }
                      {column[col.field] == 3 && 
                        <div className="status-plts status-healty">Healthy</div>
                      }
                    </>
                  : 
                  col.round == true ? formatNumber(column[col.field].toFixed(2))
                  :
                  column[col.field]
                }
              </td>
            ))}
          </tr>
        ))}

      </table>
      <div className={css.filter_pagination}>
        <div className={css.per_page}>
          Baris per halaman :
          <select onChange={onChangePerpage}>
            <option value={5}>5</option>
            <option value={10}>10</option>
            <option value={50}>50</option>
          </select>
        </div>
        <div className={css.paggination}>
          <label>{from}-{to} dari {total} Item</label>
          <div className={css.arrow}>
            {prev_page == null ? <i class="fi fi-rr-angle-small-left" style={{cursor:'not-allowed'}}></i> : <i class="fi fi-rr-angle-small-left" style={{cursor:'pointer'}} onClick={HandlePrevItem}></i> }
            {next_page == null ? <i class="fi fi-rr-angle-small-right" style={{cursor:'not-allowed'}}></i> : <i class="fi fi-rr-angle-small-right" style={{cursor:'pointer'}} onClick={HandleNextItem}></i>}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ATable;
